module.exports = __webpack_public_path__ + "static/img/news_reader_logo.28f1b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/news_reader_logo.png
// module id = qCKT
// module chunks = 0